import { withInstall } from '@lit-element/utils'
import TimeAgo from './src/time-ago.vue'

import type { SFCWithInstall } from '@lit-element/utils'

export const LtTimeAgo: SFCWithInstall<typeof TimeAgo> = withInstall(TimeAgo)
export default LtTimeAgo

export * from './src/time-ago'
